<template>
  <div class="option-wrap">
    <div class="left">
      <div class="li">
        <el-select
          v-model="firstOptions"
          clearable
          placeholder="可筛选部分客户"
          size="mini"
          @change="selectType"
          style="width: 150px; margin-right: 10px "
        >
          <el-option
            v-for="item in operationOptions"
            :key="item.status"
            :label="item.label"
            :value="item.status"
          >
          </el-option>
        </el-select>
        <SelectOption
          ref="mySelectOption"
          :myType="firstOptions"
          :index="-1"
          :cusStatuOptions="cusStatuOptions"
          :areaContain="areaContain"
          @selectValue="selectValue"
        />
        <el-row>
          <el-button
            type="primary"
            size="mini"
            plain
            icon="el-icon-plus"
            @click="addRow"
          ></el-button>
        </el-row>
      </div>
      <div class="li" v-for="(item, index) in itemList" :key="item.id">
        <el-select
          v-model="item.options"
          clearable
          placeholder="可筛选部分客户"
          @change="selectType"
          size="mini"
          style="width: 150px; margin-right: 10px "
        >
          <el-option
            v-for="item in operationOptions"
            :key="item.status"
            :label="item.label"
            :value="item.status"
          >
          </el-option>
        </el-select>
        <SelectOption
          :myType="item.options"
          :index="index"
          :cusStatuOptions="cusStatuOptions"
          :areaContain="areaContain"
          @selectValue="selectValue"
        />
        <el-row>
          <el-button
            type="primary"
            size="mini"
            plain
            icon="el-icon-plus"
            @click="addRow"
          ></el-button>
          <el-button
            type="warning"
            size="mini"
            plain
            icon="el-icon-minus"
            @click="delRow(index)"
          ></el-button>
        </el-row>
      </div>
    </div>
    <div class="right">
      <el-switch
        style="display: block"
        v-model="params.andOr"
        :disabled="andOrBtnDisAble"
        active-value="or"
        inactive-value="and"
        active-color="#E6E9EB"
        @change="swichChange"
        active-text="或"
        inactive-text="且"
      >
      </el-switch>
    </div>
  </div>
</template>
<script>
import SelectOption from "@/views/mass/SOP/components/selectOption.vue";
import { getHisCtmType, getHisArea, getCheckSystem } from "@/api/sop/sop.js";
export default {
  name: "selectContain",
  components: {
    SelectOption,
  },
  props: {},
  data() {
    return {
      itemList: [
        // {
        //   id: '',
        //   options: '',
        //   valueContain: {
        //      attributeName: '',
        //      value: []
        //   }
        // }
      ],
      params: {
        ctmTagId: [],
        ctmType: [],
        birthday: [],
        sex: [],
        area: [],
        isBlacklist: [],
        andOr: "and",
      },
      firstOptions: "",
      firstValue: {},
      operationOptions: [
        {
          status: "1",
          label: "企微标签",
        },
        {
          status: "2",
          label: "客户状态",
        },
        {
          status: "3",
          label: "生日",
        },
        {
          status: "4",
          label: "性别",
        },
        // {
        //   status: '5',
        //   label: "省市区",
        // },
      ],
      dataNum: 0,
      cusStatuOptions: [], // 客户状态选项
      areaContain: { area: [] }, // 存放地址选项，{isChongGou:true,area:[]}
      /** 获取当前系统信息 0经典;  1云医美1.0； 2云医美4.0； 3客云 */
      currentSystem: null,
    };
  },
  async created() {
    this.getHisCtmType();
    this.getSystem();
    // let areaContain = this.$store.state.tagsView.areaContain
    // if(JSON.stringify(areaContain) != '{}') {
    //   this.areaContain.area = areaContain
    //   if(areaContain.isChongGou) {
    //     let obj = {
    //       status: '6',
    //       label: "黑名单客户",
    //     }
    //     this.operationOptions.push(obj)
    //   }
    // }else {
    await this.getArea();
    // }
  },
  watch: {},
  computed: {
    andOrBtnDisAble() {
      let arr = [];
      if (this.firstOptions) {
        arr.push(this.firstOptions);
      }
      this.itemList.forEach((item) => {
        if (item.options) {
          arr.push(item.options);
        }
      });
      // 判断选择的大类有没有重复的，有的话，筛选条件改为或并改为不可选，否则改为可选
      const set = new Set();
      for (let i = 0; i < arr.length; i++) {
        if (set.has(arr[i])) {
          this.params.andOr = "or";
          return true;
        } else {
          set.add(arr[i]);
        }
      }
      return false;
    },
  },
  methods: {
    // 选择大类的时候触发
    selectType() {
      // this.sendFor()
    },
    swichChange(val) {
      this.sendFor();
    },
    addRow() {
      this.itemList.push({
        id: this.dataNum++,
        options: "",
        valueContain: {},
      });
    },
    delRow(index) {
      this.itemList.splice(index, 1);
      this.sendFor();
    },
    initData() {
      this.itemList = [];
      this.firstOptions = "";
      this.firstValue = {};
      this.params.andOr = "and";
      this.dataNum = 0;
      this.$refs.mySelectOption.initParams();
    },
    selectValue(index, val) {
      console.log("selectValueVal", val);
      if (index == -1) {
        this.firstValue = val;
      } else {
        this.itemList[index].valueContain = val;
      }
      this.sendFor();
    },
    sendFor() {
      let arr = [
        "ctmTagId",
        "ctmType",
        "birthday",
        "sex",
        "area",
        "isBlacklist",
      ];
      arr.forEach((item) => {
        this.params[item] = [];
      });

      if (this.firstValue.attributeName) {
        this.params[this.firstValue.attributeName].push(this.firstValue.value);
      }
      this.itemList.forEach((item) => {
        if (item.valueContain.attributeName) {
          this.params[item.valueContain.attributeName].push(
            item.valueContain.value
          );
        }
      });
      this.$emit("selectOptions", this.params);
    },
    // 获取客户状态选项
    getHisCtmType() {
      getHisCtmType(localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          this.cusStatuOptions = res.data.ctmType;
        }
      });
    },
    // 获取地区
    getArea() {
      getHisArea(localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          this.$store.dispatch("tagsView/setArea", res.data);
          this.areaContain.area = res.data;
          if (res.data.isChongGou) {
            let obj = {
              status: "6",
              label: "黑名单客户",
            };
            this.operationOptions.push(obj);
          }
        }
      });
    },

    /** 获取当前平台 0经典;  1云医美1.0； 2云医美4.0； 3客云  */
    getSystem() {
      getCheckSystem(localStorage.getItem("Authorization")).then((res) => {
        if (res && res.error && res.error.code == 200) {
          console.log("res+++++", res);
          this.currentSystem = res.data;
          if (this.currentSystem == 3) {
            this.operationOptions = [
              {
                status: "1",
                label: "企微标签",
              },
              {
                status: "2",
                label: "客户状态",
              },
              {
                status: "3",
                label: "生日",
              },
              {
                status: "4",
                label: "性别",
              },
              {
                status: "5",
                label: "省市区",
              },
            ];
          } else {
            this.operationOptions = [
              {
                status: "1",
                label: "企微标签",
              },
              {
                status: "2",
                label: "客户状态",
              },
              {
                status: "3",
                label: "生日",
              },
              {
                status: "4",
                label: "性别",
              },
            ];
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.option-wrap {
  border: 1px solid #e6e9eb;
  display: flex;
  align-items: center;
  .left {
    flex: 1;
    border-right: 1px solid #eeeff3;
    padding: 9px 12px;
    max-width: 402px;
    .li {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      &:last-child {
        margin-bottom: 0;
      }
      /deep/.el-button--mini {
        padding: 5px 7px;
      }
    }
  }

  /deep/.right {
    padding: 0 22px;
    .el-switch__label {
      color: #dcdfe6;
    }
    .is-active {
      color: #409eff;
    }
  }
}
</style>
